import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 27 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.37 2.762a11.368 11.368 0 1 0 11.367 11.37.875.875 0 0 0-.875-.876h-9.62V3.637a.875.875 0 0 0-.873-.875Zm9.58 12.243A9.62 9.62 0 1 1 11.495 4.551v9.58a.875.875 0 0 0 .874.875h9.581Z",
      fill: "#E6ACAA",
      stroke: "#E6ACAA",
      "stroke-width": ".75"
    }, null, -1),
    _createElementVNode("path", {
      d: "M15.962.505a.876.876 0 0 0-.97.87v9.258a.875.875 0 0 0 .875.875h9.258a.876.876 0 0 0 .87-.97A11.428 11.428 0 0 0 15.962.505Zm.78 9.253V2.402a9.687 9.687 0 0 1 7.356 7.356h-7.356Z",
      fill: "#E6ACAA",
      stroke: "#E6ACAA",
      "stroke-width": ".75"
    }, null, -1)
  ]))]))
}
export default { render: render }